import React, { PureComponent } from "react";
import HighchartsReact from "highcharts-react-official";
import * as Highcharts from "highcharts";
import { mFormatter, getSentimentColor } from "../utils";
import { numberWithCommas } from "../../utils";
import HighchartsCustomEvents from "highcharts-custom-events";

HighchartsCustomEvents(Highcharts);
class PlatformWiseSentimentAnalysisChart extends PureComponent {
    state = {};

    chartComponent = React.createRef();
    // componentDidUpdate(prevProps) {
    //     if (this.props.resizedCount !== prevProps.resizedCount && this.props.data && !this.props.data.nodata) {
    //         this.chartComponent.current.chart.setSize(null, null);
    //         this.chartComponent.current.chart.reflow();
    //     }
    // }

    componentDidMount() {
        this.ro = new ResizeObserver(() => {
            setTimeout(() => {
                this.chartComponent?.current?.chart.setSize(null, null);
                this.chartComponent?.current?.chart.reflow();
            }, 0);
        });
        if (this.props.widgetContainerRef.current) {
            this.ro.observe(this.props.widgetContainerRef.current);
        }
    }

    componentWillUnmount() {
        this.ro.disconnect();
    }

    formatSentimentData(data) {
        let res = [];
        for (let platform in data) {
            let platformName = this.props.allPlatforms.find((plt) => plt.id === platform);
            platformName = platformName ? platformName.short_name : "";
            res.push({
                name: platformName,
                data: data[platform].sentiments,
                total: data[platform].total,
                id: platform,
            });
        }
        return res;
    }

    formatDataDonut(data, name, total) {
        let labelOrder = ["positive", "negative", "neutral"];

        let res = {};
        let columns = data;
        res.name = name;
        res.total = total;

        let a = [];

        columns.sort((a, b) => labelOrder.indexOf(a[0]) - labelOrder.indexOf(b[0]));

        columns.map((item) => {
            a.push({
                doc_count: item[1],
                mediaType: item[0],
                name: item[0],
                y: item[1],
                color: getSentimentColor(item[0]),
            });
        });

        res.data = a;

        return res;
    }

    getOptions = (data) => {
        let { positive, negative, neutral } = this.props.data;

        let self = this;

        const chartConfig = {
            chart: {
                type: "bar",
                //height: 150 * this.props.data.keys.length,
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            title: {
                text: " ",
            },
            xAxis: {
                type: "category",
                lineColor: "#ccd6eb",
                lineWidth: 1,
            },
            yAxis: {
                gridLineWidth: this.props.showGridLines ? 2 : 0,
                gridLineDashStyle: "shortdash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                max: 100,
                title: "",
                labels: {
                    format: "{text}%",
                },
            },
            legend: {
                enabled: this.props.showLegend,
                align: "center",
                x: 0,
                y: 0,
            },
            series: [
                {
                    name: "Positive",
                    data: positive,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("positive"),
                    marker: {
                        fillColor: getSentimentColor("positive"),
                        symbol: "square",
                    },
                },
                {
                    name: "Negative",
                    data: negative,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("negative"),
                    marker: {
                        fillColor: getSentimentColor("negative"),
                        symbol: "square",
                    },
                },
                {
                    name: "Neutral",
                    data: neutral,
                    dataLabels: {
                        color: "black",
                    },
                    color: getSentimentColor("neutral"),
                    marker: {
                        fillColor: getSentimentColor("neutral"),
                        symbol: "square",
                    },
                },
            ],
            plotOptions: {
                series: {
                    borderWidth: 0,
                    stacking: "normal",
                    dataLabels: {
                        enabled: this.props.showLabel,
                        style: {
                            fontWeight: "bold",
                            textOutline: "none",
                        },
                        formatter: function () {
                            if (this.y >= 8) {
                                return `${this.y} %`;
                            }
                        },
                    },
                },
                bar: {
                    point: {
                        events: {
                            contextmenu: function (e) {
                                console.log("1111111 2", this);
                                e.preventDefault();
                                self.props.addContextMenuListener(e.x, e.y, this);
                            },
                        },
                    },
                },
            },
            tooltip: {
                shared: true,

                //headerFormat: "<span>{point.key}</span><br />",
                backgroundColor: "#fff",
                borderColor: "#fff",
                borderRadius: 6,
                followPointer: true,
                followTouchMove: true,
                useHTML: true,

                // positioner: function(labelWidth, labelHeight, point) {
                //     console.log("first",point)
                //     var tooltipX = point.plotX ;
                //     var tooltipY = point.plotY +22 ;
                //     return {
                //         x: tooltipX,
                //         y: tooltipY
                //     };
                // },

                //pointFormat: '<span">{series.name}</span>: <b>{point.y}%</b> | <b>{point.doc_count}/{point.totData}</b><br/>',

                formatter: function () {
                    let tot = 0;
                    let sentiment = { positive: { value: 0, percentage: 0 }, negative: { value: 0, percentage: 0 }, neutral: { value: 0, percentage: 0 } };
                    this.points.map((point) => {
                        tot = point.point.totalData;
                        sentiment[point.point.sentiment].value = point.point.doc_count;
                    });

                    sentiment.positive.percentage = sentiment.positive.value ? ((sentiment.positive.value / tot) * 100).toFixed(2) : 0;
                    sentiment.negative.percentage = sentiment.negative.value ? ((sentiment.negative.value / tot) * 100).toFixed(2) : 0;
                    sentiment.neutral.percentage = sentiment.neutral.value ? ((sentiment.neutral.value / tot) * 100).toFixed(2) : 0;

                    return `<span><b>${this.points[0].key}</b></span><br />


                    <span style="border:0px solid gray;display:block;border-radius:4px;width:250px;padding:0px 1px;">
                        <span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;">
                         <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${getSentimentColor(
                             "positive",
                         )};border-radius:10px" ></span> <span style="display:inline-block;width:70px;"><b>Positive</b> </span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                        sentiment.positive.percentage + "%"
                    }</b> </span> <span style="display:inline-block;padding:1px;margin-left:10px"><b>(${numberWithCommas(
                        sentiment.positive.value,
                    )} / ${numberWithCommas(tot)})</b> </span><br/> </span>

                    <span style="border:0px solid gray;display:block;border-radius:4px;width:250px;padding:0px 1px;">
                        <span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;">
                         <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${getSentimentColor(
                             "negative",
                         )};border-radius:10px" ></span> <span style="display:inline-block;width:70px;"> <b>Negative</b> </span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                        sentiment.negative.percentage + "%"
                    }</b> </span> <span style="display:inline-block;padding:1px;margin-left:10px"><b>(${numberWithCommas(
                        sentiment.negative.value,
                    )} / ${numberWithCommas(tot)})</b> </span><br/> </span>


                    <span style="border:0px solid gray;display:block;border-radius:4px;width:250px;padding:0px 1px;">
                        <span style="dispaly:inline-block;margin-bottom:20px;border-right:0px solid gray;padding:3px;">
                         <span style="margin-right:4px;display:inline-block;width:8px;height:8px;background-color:${getSentimentColor(
                             "neutral",
                         )};border-radius:10px" ></span> <span style="display:inline-block;width:70px;"><b>Neutral </b></span></span> <span style="display:inline-block;padding:1px 2px;width:42px;"><b> ${
                        sentiment.neutral.percentage + "%"
                    }</b> </span> <span style="display:inline-block;padding:1px;margin-left:10px"><b>(${numberWithCommas(
                        sentiment.neutral.value,
                    )} / ${numberWithCommas(tot)})</b> </span><br/> </span>
                  
                   `;
                },
                outside: true,
                style: {
                    fontWeight: "normal",
                    zIndex: 0,
                },
            },
        };

        return chartConfig;
    };

    render() {
        return (
            <HighchartsReact
                ref={this.chartComponent}
                highcharts={Highcharts}
                options={this.getOptions()}
                containerProps={{ style: { width: "100%", height: "100%" } }}
            />
        );
    }
}

export default PlatformWiseSentimentAnalysisChart;
